module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": _vm.nowTransition
    }
  }, [(_vm.isOpen) ? _c('div', {
    staticClass: "yu-popup",
    attrs: {
      "data-com": "YuPopup"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [(_vm.mask) ? _c('div', {
    staticClass: "yu-popup-mask",
    on: {
      "click": _vm.fnMaskClick
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "yu-popup-cont",
    class: [_vm.position ? 'yu-popup-' + _vm.position : 'bottom']
  }, [_vm._t("default")], 2)]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b9eef7e4","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/base/YouUI/Popup/Popup.vue
// module id = 294
// module chunks = 0